<template>
  <v-dialog v-model="mostradoModal" max-width="1200" scrollable>
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Módulos</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <v-simple-table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>N° Módulo</th>
                  <th>Módulo</th>
                  <th>Fecha Inicio</th>
                  <th>Fecha Fin</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(programaModulo, indice) in programasModulosOrdenados"
                  :key="indice"
                  :style="{ backgroundColor: indice == programasModulosOrdenados.length - 1 ? '#E3F2FD' : '' }">
                  <td>{{ indice + 1 }}</td>
                  <td class="text-right">
                    {{ programaModulo?.numero.toString() }}
                  </td>
                  <td>
                    {{ programaModulo?.modulo?.nombre }}
                  </td>
                  <td>
                    {{ programaModulo?.fechaInicio || '-' }}
                  </td>
                  <td>
                    {{ programaModulo?.fechaFin || '-' }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="blue darken-1" text @click="mostradoModal = false"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalModulos',
  props: {
    programasModulos: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    programasModulosOrdenados() {
      const programasModulos = this.programasModulos.map((pm) => ({
        ...pm,
        numero: Number(pm.numero),
      }));

      return programasModulos.sort((a, b) => a.numero - b.numero);
    },
  },
  data() {
    return {
      mostradoModal: false,
    };
  },
  methods: {
    abrir() {
      this.mostradoModal = true;
    },
  },
};
</script>

<style>
</style>